import Papa from "papaparse";

import { isValidUrl } from "./is-valid-url";

export const importTasksFromCsv = async (
  file: File
): Promise<Array<{ url: string; date?: Date, skipCutLongSentences? : boolean }>> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        console.log("results", results);

        const articles = results.data
          .map((row: any) => ({
            url: row.url?.trim(),
            date: row.date?.trim(),
            skipCutLongSentences: row.skipCutLongSentences?.trim().toLowerCase() === "true",
          }))
          .filter((article) => article.url && isValidUrl(article.url));

        resolve(articles);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
};
